import type { TicketTypes } from "@/redux/support/supportType";

export const ticketReducer = {
  resetTicketError: (state: TicketTypes) => {
    state.error = null;
  },
  resetTicketSuccess: (state: TicketTypes) => {
    state.success = null;
  },
  resetTicketMessage: (state: TicketTypes) => {
    state.message = null;
  },
  resetTicketStatusCode: (state: TicketTypes) => {
    state.statusCode = null;
  },
  resetTicketDetails: (state: TicketTypes) => {
    state.ticketDetails = null;
  },
  resetTicketComments: (state: TicketTypes) => {
    state.ticketComments = [];
  },
  resetTicketList: (state: TicketTypes) => {
    state.ticketList = null;
  },
  resetAllTicketList: (state: TicketTypes) => {
    state.allTicketList = null;
  },
  resetTicketFetching: (state: TicketTypes) => {
    state.fetching = false;
  },
};
